import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Download, Eye, Loader2 } from 'lucide-react';

const DownloadableElement = ({ config, element, onComplete, onSaveData, isCompleted }) => {
  const fileSize = config.file_size_bytes ? config.file_size_bytes > 1048576 ? `${(config.file_size_bytes / 1048576).toFixed(1)} MB` : `${(config.file_size_bytes / 1024).toFixed(0)} KB` : null;
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const handlePreview = () => {
    const fileUrl = config.file_url;
    if (!fileUrl) { toast.error('No file URL configured'); return; }
    window.open(fileUrl, '_blank');
    onSaveData({ previewed: true });
    if (!isCompleted) onComplete();
  };

  const handleDownload = async () => {
    const fileUrl = config.file_url;
    if (!fileUrl) { toast.error('No file URL configured'); return; }
    setDownloading(true); setError(null);
    try {
      if (fileUrl.includes('/api/files/')) {
        const res = await fetch(fileUrl);
        if (!res.ok) throw new Error(`Download failed (${res.status})`);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = config.file_name || 'download'; document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
      } else {
        const a = document.createElement('a'); a.href = fileUrl; a.download = config.file_name || 'download'; a.target = '_blank'; document.body.appendChild(a); a.click(); document.body.removeChild(a);
      }
      onSaveData({ downloaded: true });
      if (!isCompleted) onComplete();
    } catch (err) { setError(err.message || 'Download failed'); toast.error('Failed to download file. Please try again.'); } finally { setDownloading(false); }
  };

  return (
    <div className="p-6 bg-white border border-slate-200 rounded-xl space-y-4">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 bg-[#f8fafc] rounded-xl flex items-center justify-center"><Download className="h-7 w-7 text-[#20acf6]" /></div>
        <div className="flex-1"><h3 className="font-semibold text-slate-900">{config.file_name || 'Resource'}</h3><div className="flex gap-3 text-sm text-slate-500 mt-1">{config.file_type && <span className="uppercase">{config.file_type}</span>}{fileSize && <span>{fileSize}</span>}</div></div>
      </div>
      {config.description && <p className="text-sm text-slate-600">{config.description}</p>}
      {error && <p className="text-sm text-red-600">{error}</p>}
      <div className="flex flex-wrap gap-2">
        <Button onClick={handlePreview} variant="outline" className="border-[#20acf6] text-[#20acf6] hover:bg-[#20acf6]/5" data-testid="preview-resource-btn"><Eye className="h-4 w-4 mr-2" /> Preview</Button>
        <Button onClick={handleDownload} disabled={downloading} className="bg-[#20acf6] hover:bg-[#3bb8f7]" data-testid="download-resource-btn">{downloading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Download className="h-4 w-4 mr-2" />}{downloading ? 'Downloading...' : 'Download'}</Button>
      </div>
    </div>
  );
};

export default DownloadableElement;
